"use client";

import type React from "react";
import { useIsWebview } from "../../../components/WebviewContext/hooks";
import weatherGuideStyles from "./weatherGuide.module.scss";

type Props = {
    children: React.ReactNode;
};

const Layout: React.FC<Props> = ({ children }) => {
    const isWebview = useIsWebview();

    return (
        <div
            className={weatherGuideStyles.root}
            data-support-color-scheme-light-and-dark={isWebview}
        >
            {children}
        </div>
    );
};

export default Layout;
